"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Label = _styledComponents["default"].div.withConfig({
  displayName: "LabelFormatter__Label",
  componentId: "sc-1w6f8rw-0"
})(["width:156px;height:25px;background-color:", ";border:solid 1px ", ";font-size:12px;display:flex;justify-content:center;align-items:center;"], function (props) {
  return props.theme["light-grey"];
}, function (props) {
  return props.theme["grey"];
});

var LabelFormatter = function LabelFormatter(_ref) {
  var value = _ref.value;
  var valuesToRender = null;

  if (value) {
    if (typeof value === "string") {
      valuesToRender = value;
    } else if (Array.isArray(value)) {
      valuesToRender = value.map(function (label, index) {
        return _react["default"].createElement(Label, {
          key: index
        }, label);
      });
    }
  }

  return _react["default"].createElement("div", null, valuesToRender);
};

LabelFormatter.propTypes = {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].array]).isRequired
};
var _default = LabelFormatter;
exports["default"] = _default;